import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { VisorImagenComponent } from './visor-imagen'
import type { FotoProducto } from '../../application/sesion-captura'

/** Fila de foto libre con etiqueta editable. */
@Component({
  selector: 'app-fila-foto',
  standalone: true,
  imports: [FormsModule, VisorImagenComponent],
  templateUrl: './fila-foto.html',
})
export class FilaFotoComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) foto!: FotoProducto
  @Output() renombrar = new EventEmitter<{ id: string; etiqueta: string }>()
  @Output() eliminar = new EventEmitter<string>()

  readonly url = signal<string | undefined>(undefined)
  private urlActual?: string
  /** Ver en grande la foto ya tomada — pedido desde la feria, 2026-09-06. */
  readonly verAmpliada = signal(false)

  ngOnChanges(): void {
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
    // Blob vacio = foto ya sincronizada y limpiada localmente (>72h, ver
    // limpiarBlobsSincronizadosAntiguos en db.ts) — la real vive en Supabase.
    if (this.foto.blob.size === 0) {
      this.urlActual = undefined
      this.url.set(undefined)
      return
    }
    this.urlActual = URL.createObjectURL(this.foto.blob)
    this.url.set(this.urlActual)
  }

  ngOnDestroy(): void {
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
  }

  alCambiarEtiqueta(etiqueta: string): void {
    this.renombrar.emit({ id: this.foto.id, etiqueta })
  }

  abrirAmpliada(): void {
    if (this.url()) this.verAmpliada.set(true)
  }

  cerrarAmpliada(): void {
    this.verAmpliada.set(false)
  }
}
